import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            padding: theme.spacing(2, 0),
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gridGap: theme.spacing(1),
        },
        cardContent: {
            padding: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        button: {
            width: 100,
            paddingRight: 10,
        },
        lastButton: {
            width: 100,
            paddingLeft: 10,
        },
        doubleButtons: {
            display: 'inline-flex',
        },
        buttonWrapper: {
            width: 100,
        },
        tableWrapper: {
            maxHeight: '600px',
        },
    }
})

export default useStyles
